import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-[#3A3A3A] py-8 px-4" data-id="element-14">
        <div className="max-w-6xl mx-auto" data-id="element-15">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-16">
            <p className="text-white/60 text-sm text-center md:text-left" data-id="element-17">
              © 2026 Reset de 15 Minutos. Orden real para gente con vida real.
            </p>

            <div className="flex items-center gap-6" data-id="element-18">
              <button onClick={() => setShowPrivacy(true)} className="text-white/60 hover:text-white text-sm transition-colors duration-200 focus:outline-none focus:underline" data-id="element-19">
                Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="text-white/60 hover:text-white text-sm transition-colors duration-200 focus:outline-none focus:underline" data-id="element-20">
                Términos
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-21">
        <div className="prose prose-sm max-w-none text-[#5A5A5A] space-y-4" data-id="element-22">
          <p className="text-sm text-[#7A7A7A] italic" data-id="element-23">
            Última actualización: Febrero 2026
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-24">
            1. Información que Recopilamos
          </h3>
          <p data-id="element-25">
            Cuando adquieres "Reset de 15 Minutos (Anti-Caos)", recopilamos
            únicamente la información necesaria para procesar tu compra y
            entregarte el producto digital:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-26">
            <li data-id="element-27">Nombre y dirección de correo electrónico</li>
            <li data-id="element-28">
              Información de pago (procesada de forma segura por nuestro
              proveedor de pagos)
            </li>
            <li data-id="element-29">Dirección IP y datos de navegación básicos</li>
          </ul>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-30">
            2. Cómo Usamos Tu Información
          </h3>
          <p data-id="element-31">Utilizamos tu información para:</p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-32">
            <li data-id="element-33">Procesar tu compra y enviarte el PDF descargable</li>
            <li data-id="element-34">Enviarte actualizaciones sobre el producto (si las hay)</li>
            <li data-id="element-35">Responder a tus consultas de soporte</li>
            <li data-id="element-36">Mejorar nuestros productos y servicios</li>
          </ul>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-37">
            3. Protección de Datos
          </h3>
          <p data-id="element-38">
            Tomamos la seguridad de tus datos muy en serio. Utilizamos
            encriptación SSL y trabajamos con proveedores de pago certificados
            para proteger tu información financiera.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-39">
            4. Compartir Información
          </h3>
          <p data-id="element-40">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros, excepto cuando sea necesario para procesar tu pago o
            cumplir con requisitos legales.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-41">
            5. Tus Derechos
          </h3>
          <p data-id="element-42">Tienes derecho a:</p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-43">
            <li data-id="element-44">Acceder a tu información personal</li>
            <li data-id="element-45">Solicitar correcciones o eliminación de tus datos</li>
            <li data-id="element-46">
              Cancelar la suscripción a nuestros correos en cualquier momento
            </li>
          </ul>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-47">
            6. Cookies
          </h3>
          <p data-id="element-48">
            Utilizamos cookies básicas para mejorar tu experiencia de navegación
            y analizar el tráfico del sitio. Puedes desactivar las cookies en la
            configuración de tu navegador.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-49">
            7. Contacto
          </h3>
          <p data-id="element-50">
            Si tienes preguntas sobre esta política de privacidad, contáctanos a
            través de nuestro correo de soporte.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-51">
        <div className="prose prose-sm max-w-none text-[#5A5A5A] space-y-4" data-id="element-52">
          <p className="text-sm text-[#7A7A7A] italic" data-id="element-53">
            Última actualización: Febrero 2026
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-54">
            1. Aceptación de Términos
          </h3>
          <p data-id="element-55">
            Al comprar "Reset de 15 Minutos (Anti-Caos)", aceptas estos términos
            y condiciones. Si no estás de acuerdo, por favor no realices la
            compra.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-56">
            2. Descripción del Producto
          </h3>
          <p data-id="element-57">
            "Reset de 15 Minutos (Anti-Caos)" es un producto digital (PDF +
            imprimibles) que incluye:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-58">
            <li data-id="element-59">Método completo Timer + Zonas + Misiones</li>
            <li data-id="element-60">Misiones organizadas por zona</li>
            <li data-id="element-61">Plan para días caóticos</li>
            <li data-id="element-62">Semana de rescate</li>
            <li data-id="element-63">Tracker para 30 días</li>
          </ul>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-64">
            3. Precio y Pago
          </h3>
          <p data-id="element-65">
            El precio actual del producto es $6.39 USD (precio con descuento
            desde $19). Los pagos se procesan de forma segura a través de
            nuestro proveedor de pagos. Todos los precios están sujetos a
            cambios sin previo aviso.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-66">
            4. Entrega del Producto
          </h3>
          <p data-id="element-67">
            Después de completar tu compra, recibirás un correo electrónico con
            el enlace de descarga del PDF. El acceso es inmediato y de por vida.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-68">
            5. Política de Reembolso
          </h3>
          <p data-id="element-69">
            Debido a la naturaleza digital del producto, no ofrecemos reembolsos
            una vez que el PDF ha sido descargado. Sin embargo, si experimentas
            problemas técnicos con la descarga, contáctanos y te ayudaremos.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-70">
            6. Uso del Producto
          </h3>
          <p data-id="element-71">
            Este producto es para uso personal únicamente. No está permitido:
          </p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-72">
            <li data-id="element-73">Revender o redistribuir el contenido</li>
            <li data-id="element-74">Compartir el PDF con otras personas</li>
            <li data-id="element-75">Publicar el contenido en línea o en redes sociales</li>
            <li data-id="element-76">Usar el contenido con fines comerciales sin autorización</li>
          </ul>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-77">
            7. Propiedad Intelectual
          </h3>
          <p data-id="element-78">
            Todo el contenido de "Reset de 15 Minutos (Anti-Caos)" está
            protegido por derechos de autor. Al comprar, obtienes una licencia
            de uso personal, no la propiedad del contenido.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-79">
            8. Limitación de Responsabilidad
          </h3>
          <p data-id="element-80">
            Este producto ofrece un método de organización del hogar. Los
            resultados pueden variar según cada persona. No garantizamos
            resultados específicos y no somos responsables de cómo implementes
            el método.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-81">
            9. Modificaciones
          </h3>
          <p data-id="element-82">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación.
          </p>

          <h3 className="text-lg font-semibold text-[#3A3A3A] mt-6" data-id="element-83">
            10. Contacto
          </h3>
          <p data-id="element-84">
            Para preguntas sobre estos términos, contáctanos a través de nuestro
            correo de soporte.
          </p>
        </div>
      </Modal>
    </>;
}